import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  RESET,
  GET_CITY_LIST_SUCCESS,
  GET_COUNTRY_LIST_SUCCESS,
  GET_CLAIM_TYPES_SUCCESS,
  POLICY_VERSION_CHANGED,
  GET_COUNTRY_SUPPORTED_LIST_SUCCESS,
} from './constants';

import { mapDataForClaimType } from './mapDataForClaimType';
import { defaultCountry } from '../../FastCover/dataMapper/claimCodeMapper';

// The initial state of the App
const initialState = fromJS({
  form: {
    dateOfEvent: '',
    timeOfEvent: null,
    country: defaultCountry && defaultCountry.id && defaultCountry.name ? {
            id: defaultCountry.id,
            label: defaultCountry.name,
            value: defaultCountry.name,
          } : null,
    selectedCountry: defaultCountry && defaultCountry.id && defaultCountry.name  ? {
            id: defaultCountry.id,
            label: defaultCountry.name,
            value: defaultCountry.name,
          } : null,
    city: null,
    storyEvent: '',
    // totalAmount: '',
    title: '',
    firstName: '',
    surName: '',
    dateOfBirth: '',
    relationshipToYou: '',
    dateYouFirstBecomeAware: '',
    detailOfMedicalCondition: '',
    dateBookedTrip: '',
    dateScheduledToDepart: '',
    dateOriginallyScheduled: '',
    selectedBenefits: [],
    selectedClaimFor: [],
    whatIsTheOutstandingDuesAmount: '',
    currency: '',
    // Tour Operator
    nameOfTheTourOperator: '',
    address: '',
    cityOrTown: '',
    countryTourOperator: '',
    postalCode: '',
    contact: '',
    phoneNumber: '',
    bookingReservationNumber: '',
    destinations: '',
    cityOfDeparture: '',
    returnDestination: '',
    dateOfInitialPaymentDesposit: '',
    ifNotIncludedInThePackage: '',
    usePrimaryMemberEmailAddressForAllMember: false,
    usePrimaryMemberPhoneNumberForAllMember: false,
    purposeOfTrip: '',
  },
  countryList: [],
  countriesOfxSupported: [],
  cityList: [],
  claimTypeList: [],
  initClaimTypeList: [],
  oldEventDate: '',
  oldEventTime: null,
  policyVersionChanged: false,
});

function stepWhatHappenedReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({
          form: action.payload,
          countryList: state.getIn(['countryList']),
          countriesOfxSupported: state.getIn(['countriesOfxSupported']),
          cityList: [],
          claimTypeList: state.getIn(['claimTypeList']),
          oldEventDate: action.payload.dateOfEvent,
          oldEventTime: action.payload.timeOfEvent,
        })
        : initialState;
    case RESET:
      return initialState;
    case GET_COUNTRY_LIST_SUCCESS:
      return state.setIn(['countryList'], action.countries);
    case GET_COUNTRY_SUPPORTED_LIST_SUCCESS:
      return state.setIn(['countriesOfxSupported'], action.countries);
    case GET_CITY_LIST_SUCCESS:
      return state.setIn(['cityList'], action.cities);
    case GET_CLAIM_TYPES_SUCCESS:
      return state.setIn(['claimTypeList'], mapDataForClaimType(action.claimTypeList, action.policyTypeId, action.jsonVersion, action.showZurichUHC, action.policyTypeCode));
    case POLICY_VERSION_CHANGED:
      return state.setIn(['policyVersionChanged'], action.value);
    default:
      return state;
  }
}

export default stepWhatHappenedReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepWhatHappened/reducer.js